export const API_PARTIALS = {
    distance: {
        cityCenter: 'distance/cityCenter/',
        poi: 'distance/POI/',
    },
    accommodation: 'accommodation/',
    breadcrumbs: 'breadcrumbs/',
    globalHead: 'global-head/',
    linkspaces: 'linkspaces/',
    marketingBanner: 'marketing-banner/',
};
